import { ReactElement } from 'react';

import { useHirePlanForm } from '../../../../contexts/HirePlanFormProviderGdf';
import { GoForwardButton } from '../../GoForwardButton';
import { useWindowSizeStore } from '../../../../stores/useWindowSizeStore';
import { useLoadingStore } from '../../../../stores/useLoadingStore';
import { useRouteLoaderData } from 'react-router-dom';

export function ConfirmForm(): ReactElement {
  const { handleSubmit, navigateToProposta } = useHirePlanForm();
  const data: any = useRouteLoaderData('token-servidor');
  const loading = useLoadingStore(state => state.loading);
  const produtosGDF = [993, 994, 998, 999, 1000];

  const width = useWindowSizeStore(state => state.width);

  return (
    <form
      action=""
      className="max-w-[766px] w-full"
      onSubmit={handleSubmit(navigateToProposta)}
    >
      {produtosGDF.includes(data?.produtoComercial?.id_prodcomerc) ? (
        <>
          <h2 className="text-[2rem] font-semibold text-center text-primary-main">
            Suas informações foram recebidas com sucesso!
          </h2>
          <p className="font-normal mt-1 text-center mb-8">
            Caso o e-mail tenha sido preenchido corretamente, em breve, você
            receberá a confirmação do benefício Odontológico subsidiado pelo
            Governo do Distrito Federal.
          </p>
        </>
      ) : (
        <>
          <h2 className="text-[2rem] font-semibold text-center text-primary-main notranslate">
            Suas informações foram recebidas com sucesso!
          </h2>
          <p className="font-normal mt-1 text-center mb-8">
            Após a assinatura do contrato você receberá um e-mail de boas
            vindas, lembre-se é obrigatório autorizar o débito em folha junto ao
            órgão competente gestor da Folha de Pagamento para que o mesmo possa
            ser efetivado.
          </p>
          <p className="font-normal mt-1 text-center mb-8">
            Acesse o link abaixo com as orientações do Sou Gov sobre como
            solicitar a Assistência à Saúde Suplementar.
            <a
              href="https://www.gov.br/servidor/pt-br/acesso-a-informacao/faq/sou-gov.br/saude-suplementar/como-solicitar-assistencia-a-saude-suplementar-teste"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-main underline ml-4"
            >
              Acesse aqui
            </a>
          </p>
        </>
      )}
      <p className="font-normal mt-1 text-center mb-8">
        Clique no botão abaixo para ir para tela de confirmação.
      </p>
      <p className="font-normal font-semibold mt-1 text-center mb-8">
        Baixe o aplicativo da Odontogroup e encontre um dentista mais próximo de
        você!
      </p>

      <GoForwardButton
        disabled={loading}
        desktopText={loading ? '' : 'Finalizar compra'}
        mobileText={loading ? '' : 'Finalizar compra'}
      />
    </form>
  );
}
